/**
 * Base URL publique Supabase Storage (`…/storage/v1/object/public`).
 * Préfère VITE_STORAGE_PUBLIC_BASE_URL ; repli sur VITE_SUPABASE_URL (dev / migration).
 */
function getStoragePublicBaseUrl(): string | null {
  const explicit = import.meta.env.VITE_STORAGE_PUBLIC_BASE_URL?.trim()
  if (explicit) {
    return explicit.replace(/\/+$/, '')
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
  if (supabaseUrl) {
    return `${supabaseUrl.replace(/\/+$/, '')}/storage/v1/object/public`
  }

  return null
}

/**
 * Resolves a profile avatar value (storage path or legacy URL) to a display URL.
 * Bucket `avatars` is public — no signed URL needed.
 */
export function resolveAvatarUrl(avatar: string | null | undefined): string | null {
  if (!avatar) return null
  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar
  }

  const storagePublicBase = getStoragePublicBaseUrl()
  if (!storagePublicBase) {
    return null
  }

  const normalizedPath = avatar.replace(/^\/+/, '')
  // Clé objet dans le bucket `avatars` (ex. `avatars/{userId}/…` renvoyée par l’API upload)
  return `${storagePublicBase}/avatars/${normalizedPath}`
}

/**
 * Builds initials for avatar fallback from name parts or full name.
 */
export function getAvatarInitials(
  firstName?: string | null,
  lastName?: string | null,
  name?: string | null
): string {
  const first = firstName?.trim()
  const last = lastName?.trim()
  if (first || last) {
    const initials = `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase()
    return initials || '?'
  }
  const fullName = name?.trim()
  if (fullName) {
    return fullName[0]?.toUpperCase() ?? '?'
  }
  return '?'
}
